import { render, staticRenderFns } from "./SiteSearch.vue?vue&type=template&id=5527d860"
import script from "./SiteSearch.vue?vue&type=script&lang=js"
export * from "./SiteSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports